// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e01186a8","453":"80e1a6ae"}[chunkId] + ".chunk.js";
};